<template>
  <div class="right-overview">
    <div v-if="showOverview"> <MonitoreOverview :scopeId="scopeId" /></div>
    <div v-if="showHistoryTrace"> <HistoryTrace  /></div>
    <div v-if="showRealTrace"> <RealTimeTrace  /></div>
    <div v-if="showPlan"> <PlanOverview  :sceneId="sceneId" /></div>
  </div>
</template>

<script>
import bus from '@/utils/bus'
import MonitoreOverview from './monitoreOverview.vue'
import RealTimeTrace from './realTimeTrace.vue'
import HistoryTrace from './historyTrace.vue'
import PlanOverview from './planOverview.vue'
export default {
  name: 'RightContent',
  components: { MonitoreOverview, RealTimeTrace, HistoryTrace, PlanOverview },
  data () {
    return {
      showOverview: false,
      showHistoryTrace: false,
      showRealTrace: false,
      showPlan: false,
      scopeId: null,
      sceneId: null,
      carrierId: null
    }
  },
  computed: {

  },
  methods: {

  },
  mounted () {
    bus.$on('checkScope', ({ scopeId }) => {
      this.scopeId = scopeId
      this.sceneId = null
      this.showOverview = true
      this.showHistoryTrace = false
      this.showRealTrace = false
      this.showPlan = false
    })

    bus.$on('scenePlanDetail', ({ id, marker }) => {
      this.sceneId = marker.id || id
      this.showOverview = false
      this.showHistoryTrace = false
      this.showRealTrace = false
      this.showPlan = true
    })

    bus.$on('viewHistoryTrace', ({ id, marker }) => {
      this.carrierId = marker.id || id
      this.sceneId = null
      this.showOverview = false
      this.showHistoryTrace = true
      this.showRealTrace = false
      this.showPlan = false
    })
    bus.$on('viewRealTimeTrace', ({ id, marker }) => {
      this.carrierId = marker.id || id
      this.sceneId = null
      this.showOverview = false
      this.showHistoryTrace = false
      this.showRealTrace = true
      this.showPlan = false
    })
    this.scopeId = this.$store.state.SchemaTree[0].scene_code === 'all_node' ? this.$store.state.SchemaTree.slice(1)[0].scope_id : this.$store.state.SchemaTree[0].scope_id
    this.showOverview = true
    this.showHistoryTrace = false
    this.showRealTrace = false
    this.showPlan = false
  },
  beforeDestroy () {
    bus.$off('checkScope')
    bus.$off('scenePlanDetail')
    bus.$off('viewHistoryTrace')
    bus.$off('viewRealTimeTrace')
  }
}
</script>

<style scoped lang="scss">
$bg-white: #ffffff;
$bg-gray-50: #f9fafb;
$bg-gray-100: #f3f4f6;
$bg-gray-200: #e5e7eb;
$border-color: #e5e7eb;
$text-900: #111827;
$text-700: #374151;
$text-500: #6b7280;
$text-400: #9ca3af;
$text-300: #475569;
$accent: #3b82f6;
$success: #10b981;
$warning: #f59e0b;
$danger: #ef4444;
$info: #60a5fa;
$radius: 8px;
$radius-lg: 12px;

.right-overview {
  width: 100%;
  height: 100%;
  background: $bg-white;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 16px;
  box-sizing: border-box;
  gap: 20px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: $bg-gray-200;
    border-radius: 999px;
  }
}

/* Header */
.overview-header {
  padding-bottom: 16px;
  border-bottom: 1px solid $border-color;
}

.header-title {
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 600;
  color: $text-900;
  letter-spacing: 0.5px;
}

.header-subtitle {
  margin: 0;
  font-size: 12px;
  color: $text-400;
}

/* Section Title */
.section-title {
  margin: 0 0 12px 0;
  font-size: 13px;
  font-weight: 600;
  color: $text-500;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

/* Stat Cards Grid */
.stat-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.stat-card {
  position: relative;
  background: $bg-gray-50;
  border-radius: $radius;
  padding: 14px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: hidden;
  border: 1px solid $border-color;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    border-radius: $radius $radius 0 0;
  }

  &--cyan::before {
    background: $accent;
  }

  &--amber::before {
    background: $warning;
  }

  &--red::before {
    background: $danger;
  }

  &--green::before {
    background: $success;
  }
}

.stat-card__icon {
  width: 36px;
  height: 36px;
  border-radius: $radius;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
  }

  .stat-card--cyan & {
    background: rgba(59, 130, 246, 0.1);
    color: $accent;
  }

  .stat-card--amber & {
    background: rgba(245, 158, 11, 0.1);
    color: $warning;
  }

  .stat-card--red & {
    background: rgba(239, 68, 68, 0.1);
    color: $danger;
  }

  .stat-card--green & {
    background: rgba(16, 185, 129, 0.1);
    color: $success;
  }
}

.stat-card__info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.stat-card__value {
  font-size: 20px;
  font-weight: 700;
  color: $text-900;
  line-height: 1.2;
}

.stat-card__label {
  font-size: 11px;
  color: $text-400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Gauge Section */
.gauge-section {
  padding-bottom: 16px;
  border-bottom: 1px solid $border-color;
}

.gauge-row {
  display: flex;
  justify-content: space-around;
  gap: 16px;
}

.gauge-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 110px;
}

.gauge-svg {
  width: 110px;
  height: 110px;
}

.gauge-track {
  stroke: $bg-gray-200;
}

.gauge-fill {
  transition: stroke-dasharray 0.6s ease;

  &--temp {
    stroke: $accent;
  }

  &--humidity {
    stroke: $info;
  }
}

.gauge-center {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 2px;
}

.gauge-value {
  font-size: 22px;
  font-weight: 700;
  color: $text-900;
  line-height: 1;
}

.gauge-unit {
  font-size: 11px;
  color: $text-400;
}

.gauge-label {
  margin-top: 6px;
  font-size: 11px;
  color: $text-500;
  text-align: center;
}

/* Alert Section */
.alert-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.alert-section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.alert-section__link {
  font-size: 12px;
  color: $accent;
  text-decoration: none;

  &:hover {
    color: #1d4ed8;
  }
}

.alert-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: $bg-gray-200;
    border-radius: 999px;
  }
}

.alert-item {
  padding: 10px 12px;
  border-left: 4px solid;
  border-radius: 0 $radius $radius 0;

  &.border-red {
    border-left-color: $danger;
    background: rgba(239, 68, 68, 0.05);
  }

  &.border-orange {
    border-left-color: $warning;
    background: rgba(245, 158, 11, 0.05);
  }

  &.border-blue {
    border-left-color: $accent;
    background: rgba(59, 130, 246, 0.05);
  }

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    font-size: 12px;
    font-weight: 500;
    color: $text-700;
  }

  &__time {
    font-size: 10px;
    color: $text-400;
  }

  &__desc {
    font-size: 11px;
    color: $text-500;
    margin: 2px 0 0;
  }
}

.alert-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-size: 12px;
  color: $text-400;
}
</style>
